module.exports = __webpack_public_path__ + "assets/img/main_background_wo.4a8b1952.jpg";